import {download, get, post} from "@/utils/http"

export const _selectPages = params => get("/abcQrCode/selectPages", params);
export const _get = params => get("/abcQrCode/get", params);
export const _genQrCode = params => post("/abcQrCode/genQrCode", params);
export const _updateStatus = params => get("/abcQrCode/updateStatus", params);
export const _delete = params => get("/abcQrCode/delete", params);
export const _download = params => download("/abcQrCode/download", params);



